import { useContext, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasDenominacoesGenericas from './subabasDenominacoesGenericas';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import CustomSpan from '../../../../components/CustomSpan';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { clearDenominacoesGenericasMemoryCache } from '../../../../services/cache/useDenominacoesGenericasCache';
import { useAcondicionamento } from '../../../../services/enum/useAcondicionamento';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useGrupoFinanciamento } from '../../../../services/enum/useGrupoFinanciamento';
import { useTipoProduto } from '../../../../services/enum/useTipoProduto';
import { useUmidadeProduto } from '../../../../services/enum/useUmidadeProduto';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getDenominacaoGenerica } from '../../../../services/produtosDAF/denominacoesGenericasService';
import { getAllKitDeProdutoPorDenominacoId } from '../../../../services/produtosDAF/kitProdutoService';
import { getProdutosByDenominacaoGenericaId } from '../../../../services/produtosDAF/produtosDafService';
import { formataNomeMeioSiglas, formatDate } from '../../../../utils/functions';
import {
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';
import {
  headersKitsProdutos,
  valoresExibidosOffCanvasKitProdutos,
} from '../Kits/auxiliarKitProdutos';
import {
  headersProdutos,
  valoresExibidosProdutos,
} from '../Produtos/auxiliarProdutosDaf';

export default function DenominacoesFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const { cudProdutoDaf } = useContext(UserContext);

  //Enums
  const tipoProduto = useTipoProduto();
  const acondicionamentoProduto = useAcondicionamento();
  const umidadeProduto = useUmidadeProduto();
  const grupoFinanciamento = useGrupoFinanciamento();
  const componenteAf = useComponentesPaf();

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formDenominacaoGenerica, setFormDenominacaoGenerica] = useState({
    usuarioId: userID,
    tipoProduto: 0,
    denominacaoGenerica: '',
    dcb: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const denominacaoGenericaData = await getDenominacaoGenerica(id);
      setLogData(denominacaoGenericaData);
      setFormDenominacaoGenerica({
        usuarioId: userID,
        tipoProduto: denominacaoGenericaData.tipoProduto,
        dcb: denominacaoGenericaData.dcb,
        denominacaoGenerica: denominacaoGenericaData.denominacaoGenerica,
        observacoes: denominacaoGenericaData.observacoes,
      });
      triggerRefresh(); // Dispara a atualização dos logs
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
      fetchDataProdutos(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasDenominacoesGenericas(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/produtosdaf/denominacoes/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'tipoProduto') {
      const newValue = parseInt(value, 10);
      setFormDenominacaoGenerica({
        ...formDenominacaoGenerica,
        tipoProduto: newValue,
      });
    } else {
      setFormDenominacaoGenerica((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.tipoProduto) {
      errors.push('<b>Tipo de Produto</b> é obrigatório.');
    }

    if (!form.denominacaoGenerica) {
      errors.push('<b>Denominação Genérica</b> é obrigatória.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formDenominacaoGenerica);
      if (!isFormValid) return;

      const formToSend = {
        ...formDenominacaoGenerica,
        dcb: formDenominacaoGenerica.dcb ? formDenominacaoGenerica.dcb : 'NI',
      };

      // Verifica se o token existe

      const response = await httpClient.post(
        `/api/denominacaogenerica/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/produtosdaf/denominacoes/${response.data.denominacaoGenerica.id}/dadosgerais`),
        2500,
      );
      clearDenominacoesGenericasMemoryCache();

      // navigate(
      //   `/daf/produtosdaf/denominacoes/ficha/${response.data.denominacaoGenerica.id}/dadosgerais`,
      // );
    } catch (error) {
      if (isHttpError(error)) {
        const backendMessage =
          error.response?.data?.message ?? 'Erro ao salvar registro.';

        swalErro(backendMessage);
        return;
      }

      console.error('Erro ao salvar registro:', error);
      swalErro('Erro inesperado ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formDenominacaoGenerica);
      if (!isFormValid) return;

      const formToSend = {
        ...formDenominacaoGenerica,
        dcb: formDenominacaoGenerica.dcb ? formDenominacaoGenerica.dcb : 'NI',
      };

      const response = await httpClient.patch(
        `/api/denominacaogenerica/${fichaID}`,
        formToSend,
      );

      swalSave();
      clearDenominacoesGenericasMemoryCache();
      fetchData(response.data.denominacaoGenerica.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (!result) {
      return;
    }

    try {
      const produtos = await getProdutosByDenominacaoGenericaId(logData.id);

      if (produtos && produtos.length > 0) {
        swalErro(
          'Não é possível deletar uma denominação que possui um <b>Produto Farmacêutico</b> vinculado!',
        );
        return;
      }

      await httpClient.delete(`/api/denominacaogenerica/${fichaID}`);

      swalDeleteConfirm();
      navigate('/daf/produtosdaf/denominacoes');
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(
          error.response?.data.message ||
            'Erro inesperado ao tentar excluir o registro.',
        );
      } else {
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
      console.error('Erro ao excluir registro:', error);
    }
  };

  const [dataProdutos, setDataProdutos] = useState<any[]>([]);
  const [dataKits, setDataKits] = useState<any[]>([]);
  const fetchDataProdutos = async (id: string) => {
    try {
      const produtos = await getProdutosByDenominacaoGenericaId(id);
      if (produtos.length > 0) {
        setDataProdutos(produtos);
      }

      const kits = await getAllKitDeProdutoPorDenominacoId(id);
      if (kits.length > 0) {
        setDataKits(kits);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Produtos
  const tableProdutos = dataProdutos.map((item) => {
    // Obtendo tipoProduto de forma segura
    const tipoProdutoInfo =
      item?.denominacaoGenerica?.tipoProduto !== undefined &&
      tipoProduto?.[item.denominacaoGenerica.tipoProduto]
        ? tipoProduto[item.denominacaoGenerica.tipoProduto].label
        : 'Não informado';

    return {
      id: item?.id ?? 'Não informado',
      status: <BolinhaTabelaStatus status={item?.statusDistribuicao ?? 'N'} />,
      tipoProduto: tipoProdutoInfo,
      compBasico: <BolinhaTabelaStatus status={item?.compBasico ?? 'N'} />,
      compEspecializado: (
        <BolinhaTabelaStatus status={item?.compEspecializado ?? 'N'} />
      ),
      compEstrategico: (
        <BolinhaTabelaStatus status={item?.compEstrategico ?? 'N'} />
      ),
      compOncologico: (
        <BolinhaTabelaStatus status={item?.compOncologico ?? 'N'} />
      ),
      compRara: <BolinhaTabelaStatus status={item?.compRara ?? 'N'} />,
      produtoFarmaceutico: item?.produtoFarmaceutico ?? 'Não informado',
    };
  });
  const offCanvasProdutos = dataProdutos.map((item) => {
    // Obtendo tipoProduto de forma segura
    const tipoProdutoInfo =
      item?.denominacaoGenerica?.tipoProduto !== undefined &&
      tipoProduto?.[item.denominacaoGenerica.tipoProduto]
        ? tipoProduto[item.denominacaoGenerica.tipoProduto].label
        : 'Não informado';

    return {
      id: item?.id ?? 'Não informado',
      produto: <b>{item?.produtoFarmaceutico ?? 'Não informado'}</b>,
      tipoProduto: tipoProdutoInfo,
      umidade: umidadeProduto?.[item.umidade]?.label ?? 'Não informado',
      acondicionamento:
        acondicionamentoProduto?.[item.acondicionamento]?.label ??
        'Não informado',
      oncologico: item?.oncologico === 'S' ? 'Sim' : 'Não',
      biologico: item?.biologico === 'S' ? 'Sim' : 'Não',
      status:
        item?.statusDistribuicao === 'S' ? (
          <CustomSpan texto="Ativo" />
        ) : (
          <CustomSpan texto="Inativo" />
        ),
      compBasico:
        item?.compBasico === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      compEspecializado:
        item?.compEspecializado === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      grupoEspecializado:
        grupoFinanciamento?.[item.especializadoGrupo]?.label ?? 'Não se aplica',
      compEstrategico:
        item?.compEstrategico === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      usoHospitalar:
        item?.usoHospitalar === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      farmaciaPopular:
        item?.farmaciaPopular === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      sigtap: item?.sigtapCodigo
        ? `${item.sigtapCodigo} ${item.sigtapNome}`
        : 'Não informado',
      sismat: item?.sismatCodigo
        ? `${item.sismatCodigo} ${item.sismatNome}`
        : 'Não informado',
      catmat: item?.catmatCodigo
        ? `${item.catmatCodigo} ${item.catmatNome}`
        : 'Não informado',
      obm: item?.obmCodigo
        ? `${item.obmCodigo} ${item.obmNome}`
        : 'Não informado',
      tags: item?.tags || 'Não informado',
      observacoes: item?.observacoes || 'Não informado',
    };
  });

  //Kits de Produtos
  const tableKits = dataKits.map((item) => ({
    id: item.id,
    // statusKit: item.statusKit ? statusKit[item.statusKit].label : null,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF:
      componenteAf.find(
        (option) => option.value === item.componenteAF.toString(),
      )?.label || 'Não informado',
    nomeKit: item.nomeKit,
    produtos:
      item.produtos.length > 0 ? (
        <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
          {item.produtos
            .sort((a: any, b: any) =>
              a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
            ) // Ordena os produtos
            .map((produto: any, index: number) => (
              <li key={index} style={{ marginBottom: '5px' }}>
                <b>{produto.produtoFarmaceutico}</b>
                <br />
                <span
                  style={{
                    marginLeft: '0px',
                  }}
                >
                  Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                  unidades
                </span>
              </li>
            ))}
        </ul>
      ) : (
        <span style={{ fontStyle: 'italic', color: '#888' }}>
          Não informado
        </span>
      ),
  }));

  const offCanvasKits = dataKits.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    // statusKit: item.statusKit ? statusKit[item.statusKit].label : null,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF: item.componenteAF
      ? componenteAf[item.componenteAF].label
      : null,
    nomeKit: item.nomeKit,
    descricao: item.descricao,
    produtos: (
      <ul style={{ marginBottom: '2px' }}>
        {item.produtos
          .sort((a: any, b: any) =>
            a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
          ) // Ordena os produtos
          .map((produto: any, index: number) => (
            <li key={index} style={{ marginBottom: '5px' }}>
              <b>{produto.produtoFarmaceutico}</b>
              <br />
              <span
                style={{
                  marginLeft: '0px',
                }}
              >
                Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                unidades
              </span>
            </li>
          ))}
      </ul>
    ),

    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/produtosdaf/denominacoes"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && (
            <Log
              {...logs}
              entity="TB_DENOMINACAO_GENERICA"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Denominação Genérica */}
          <BoxConteudo boxTitulo="Dados da Denominação Genérica">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="15%">
                <SelectInput
                  name="tipoProduto"
                  options={tipoProduto}
                  label="Tipo de Produto"
                  value={formDenominacaoGenerica.tipoProduto}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="10%">
                <Input
                  id="dcb"
                  name="dcb"
                  value={formDenominacaoGenerica.dcb}
                  label="DCB"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="75%">
                <Input
                  id="denominacaoGenerica"
                  name="denominacaoGenerica"
                  value={formDenominacaoGenerica.denominacaoGenerica}
                  label="Denominação Genérica"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <Col md="12">
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formDenominacaoGenerica.observacoes}
                  label="Observações"
                  type="textarea"
                  onChange={handleChange}
                />
              </Col>
            </CustomRow>
          </BoxConteudo>

          {fichaID !== 'undefined' && (
            <>
              {/* Produtos Farmacêuticos */}
              <BoxConteudo
                boxTitulo="Produtos Farmacêuticos"
                helpText="Produtos Farmacêuticos vinculados a esta denominação genérica."
              >
                <CustomCol width="100%">
                  <Tabela
                    headers={
                      headersProdutos as {
                        text: string;
                        width: number;
                        key: string;
                      }[]
                    }
                    dataTable={tableProdutos}
                    displayValues={valoresExibidosProdutos}
                    rowClickable={false}
                    showPagination={false}
                    dataOffCanvas={offCanvasProdutos}
                    pathOffcanvas="daf/produtosdaf/produtos"
                  />
                </CustomCol>
              </BoxConteudo>

              {/* Kit de Produtos */}
              <BoxConteudo
                boxTitulo="Kits de Produtos Farmacêuticos"
                helpText="Kits de Produtos Farmacêuticos vinculados a esta denominação genérica."
              >
                <CustomCol width="100%">
                  <Tabela
                    headers={headersKitsProdutos}
                    dataTable={tableKits}
                    displayValues={valoresExibidosOffCanvasKitProdutos}
                    rowClickable={false}
                    showPagination={false}
                    dataOffCanvas={offCanvasKits}
                    pathOffcanvas="daf/produtosdaf/kits"
                  />
                </CustomCol>
              </BoxConteudo>
            </>
          )}
        </WorkspaceFicha>
      </ContainerConteudo>
      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            deleteDisabled={!cudProdutoDaf}
            save
            onClickSave={handleUpdate}
            saveDisabled={!cudProdutoDaf}
          />
        ) : (
          <WorkspaceBotoes
            save
            onClickSave={handleCreate}
            saveDisabled={!cudProdutoDaf}
          />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
